import { VisitType } from "../models/visit-type";
import { BaseDecisionTreeViewerApi } from "./base";

export class VisitTypeApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ model: VisitType, baseURL: "/ehr_visit_types" });
  }
}

let api;

export const useVisitTypeApi = () => {
  api ??= new VisitTypeApi();

  return {
    all: async () => api.get(),
  };
};
